import React from 'react'
import City from '../../features/admin/Region/City'

const CityPage = () => {
  return <City />
}

export default CityPage